// extracted by mini-css-extract-plugin
export var container = "_4o-1";
export var cornerButtonContainer = "_4o-5";
export var disabled = "_4o-2";
export var fileContainer = "_4o-4";
export var hiddenInput = "_4o-3";
export var widthContainer = "_4o-0";